import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { SlicePipe } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { CustomizerSettingsService } from '../../../../customizer-settings/customizer-settings.service';
import { TranslocoModule } from '@ngneat/transloco';
import * as XLSX from 'xlsx';
import { Vulnerability } from '../../../../interfaces/asm/models';

@Component({
    selector: 'app-vulnerability-highlights',
    standalone: true,
    imports: [
        MatCardModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatButtonModule,
        TranslocoModule,
        SlicePipe,
    ],
    templateUrl: './vulnerability-highlights.component.html',
    styleUrl: './vulnerability-highlights.component.scss',
})
export class VulnerabilityHighlightsComponent {
    displayedColumns: string[] = [
        'type',
        'vulnerability',
        'severity',
        'vulnerableURL',
    ];
    @Input() data: Vulnerability[] = [];
    dataSource: MatTableDataSource<Vulnerability> = new MatTableDataSource<Vulnerability>(this.data);

    pageSizes = [10, 20, 50, 1000];

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('TABLE') table: ElementRef;

    // isToggled
    isToggled = false;

    constructor(public themeService: CustomizerSettingsService) {
        this.themeService.isToggled$.subscribe((isToggled) => {
            this.isToggled = isToggled;
        });
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    // Dark Mode
    toggleTheme() {
        this.themeService.toggleTheme();
    }

    // RTL Mode
    toggleRTLEnabledTheme() {
        this.themeService.toggleRTLEnabledTheme();
    }

    // changeData
    changeData() {
        this.dataSource.data = this.data;
    }

    exportTOExcel() {
        const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
            this.table.nativeElement
        );
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'VulnerabilityHighlights');

        /* save to file */
        XLSX.writeFile(wb, 'export.xlsx');
    }
}
